import React, { useState, useEffect } from "react"
import AmountInput from "./AmountInput"
import YearsDropdown from "./YearsDropdown"
import Graphs from "./Graphs"
import styled from "styled-components"
import { fontWhite, mainBlue } from "../../styles"

const Calculator = () => {
  const [years, setYears] = useState()
  const [amount, setAmount] = useState("")

  const onAmountChange = e => {
    setAmount(e.target.value) // might need to parse to int/float?
  }

  const [graphVals, setGraphVals] = useState(null)

  const calculateEarnings = () => {
    setGraphVals(current => {
      if (current && current.years === years && current.amount === amount) {
        return current
      }
      const amountVal = parseFloat(amount)

      return {
        amount,
        investment: amountVal,
        years,
      }
    })
  }

  useEffect(() => {
    if (graphVals !== null) {
      if (graphVals.amount !== amount || graphVals.years !== years) {
        setGraphVals(null)
      }
    }
  }, [graphVals, amount, years])

  return (
    <>
      <Wrapper className=" my-5 py-3">
        {/* Years Investing Dropdown */}
        <YearsDropdown onChange={setYears} value={years} />
        {/* Amount Invested Input  */}
        <AmountInput
          onKeyPress={calculateEarnings}
          onSubmit={calculateEarnings}
          onChange={onAmountChange}
          value={amount}
        />
        {/* Calculate Button  */}
        <button
          type="submit"
          className="calculate d-inline ml-1"
          onClick={calculateEarnings}
          onKeyPress={calculateEarnings}
          onSubmit={calculateEarnings}
        >
          Calculate
        </button>
      </Wrapper>
      <span className="text-center graph-info">
        <h5 className="pt-4">
          Calculations based on ROI: <span className="text-green">12</span>% and
          estimated tax rate of <span className="text-tang">24.5</span>%
        </h5>
      </span>
      {graphVals !== null && <Graphs {...(graphVals || {})} />}
    </>
  )
}

const Wrapper = styled.span`
  button.calculate {
    background-color: ${mainBlue};
    color: ${fontWhite};
    padding: 0.75rem 2.25rem 1rem 2.25rem;
    border: none;
    border-radius: 8px;
    font-size: 20px;
  }
`

export default Calculator
